export default "__VITE_ASSET__b8236131__"